var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgileEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98415 17.0159L6.17992 16.2116L6.6032 14.9418L4.40214 15.3651L7.3651 10.5397L9.69314 10.1587C9.90479 9.72134 10.6836 8.49101 12.1058 7.06878C13.8836 5.29101 17.8625 3.34392 20.9524 3.04762C20.6561 6.13757 18.709 10.1164 16.9312 11.8942C15.509 13.3164 14.2787 14.0952 13.8413 14.3069L13.4603 16.6349L8.63494 19.5979L9.05822 17.3968L7.78838 17.8201L6.98415 17.0159ZM12.7408 10.0741C12.4135 10.4014 12.4135 10.932 12.7408 11.2593C13.068 11.5865 13.5987 11.5865 13.9259 11.2593C14.2532 10.932 14.2532 10.4014 13.9259 10.0741C13.5987 9.74679 13.068 9.74679 12.7408 10.0741ZM14.8572 7.95767C14.5299 8.28495 14.5299 8.81558 14.8572 9.14286C15.1844 9.47014 15.7151 9.47014 16.0424 9.14286C16.3696 8.81558 16.3696 8.28495 16.0424 7.95767C15.7151 7.63039 15.1844 7.63039 14.8572 7.95767Z",
    fill: "#FF7A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04764 20.9524C3.23106 20.2892 3.88574 18.6751 5.03706 17.5238C5.57886 16.982 6.19403 17.3263 6.43389 17.5661C6.67374 17.806 7.01801 18.4212 6.47621 18.963C5.32489 20.1143 3.71078 20.769 3.04764 20.9524Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgileEngine);
export default __webpack_public_path__ + "static/media/agileEngine.5f61601904e67f5a90e8a34de096d61a.svg";
export { ForwardRef as ReactComponent };